import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorHash } from '@buildium/ngx-app-utility/dist';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { JsErrorDto } from '@root/src/shared/domain/dtos/js-error.dto';
import { BrowserWindowService } from '@root/src/app/services/browser-window.service';
import { PagePerformanceDto } from '@root/src/shared/domain/dtos/page-performance.dto';
import { Exception } from '@root/src/shared/domain/dtos/exception.dto';

@Injectable({
    providedIn: 'root'
})
export class LoggingApiService {
    readonly BASE_PATH_API = BASE_PATH_API;

    constructor(
        private http: HttpClient,
        private $window: BrowserWindowService,
        private errorHash: ErrorHash) {
    }

    createJsErrorDto(exception: any): JsErrorDto {
        // check if we already have the correct dto
        if (exception.message !== undefined
            && exception.stack !== undefined
            && exception.hash !== undefined
            && exception.callstack !== undefined
            && exception.userAgent !== undefined) {
            return exception;
        }
        const hash = this.errorHash.hashErrorString(exception.toString());
        const dto: JsErrorDto = {
            message: exception.message,
            location: this.$window.nativeWindow.location.pathname,
            hash,
            callstack: exception.stack,
            userAgent: this.$window.nativeWindow.navigator.userAgent
        };
        return dto;
    }

    logWarningMessage(exception: any): void {
        this.logWarning(
            this.createJsErrorDto(exception)
        );
    }

    logPagePerformance(data: PagePerformanceDto): void {
        if (data.LoadTimeInMilliseconds !== undefined
            && data.Url !== undefined) {
            this.http.post(`${this.BASE_PATH_API}/logging/pageperformance`,
                data).subscribe();
        }
    }

    logError(data: JsErrorDto | Exception): void {
        this.http.post(`${this.BASE_PATH_API}/logging/error`,
            this.createJsErrorDto(data)).subscribe();
    }

    logWarning(data: JsErrorDto | Exception): void {
        this.http.post(`${this.BASE_PATH_API}/logging/warning`,
            this.createJsErrorDto(data)).subscribe();
    }
}
